import { authApi } from '../';
import { LoginUserModel, LoginResponse } from 'src/types';

export const loginUser = (data: LoginUserModel) =>
  authApi.post<LoginResponse>('/auth/login', data, { withCredentials: true });
